function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import { REQUEST_MARGIN_PRODUCTS, RECEIVE_MARGIN_PRODUCTS, RECEIVE_MARGIN_PRODUCT_EVENT } from '../../actions/marginProductActions';
import { RECEIVE_MARGIN_ACCT_POSITION } from '../../actions/marginActions';
var initialState = {
  products: [],
  fetching: true
};
export var marginProductReducer = function marginProductReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case REQUEST_MARGIN_PRODUCTS:
      return Object.assign({}, state, {
        fetching: true
      });
    case RECEIVE_MARGIN_PRODUCTS:
      return Object.assign({}, state, {
        products: payload,
        fetching: false
      });
    case RECEIVE_MARGIN_PRODUCT_EVENT:
      return handleReceiveMarginProductEvent(state, payload);
    case RECEIVE_MARGIN_ACCT_POSITION:
      return handleReceiveAccountPositionEvent(state, payload);
    default:
      return state;
  }
};
var handleReceiveMarginProductEvent = function handleReceiveMarginProductEvent(state, payload) {
  var productIndex = state.products.findIndex(function (product) {
    return product.AccountPosition.ProductId === payload.AccountPosition.ProductId;
  });
  if (productIndex === -1) {
    return state;
  }
  var updatedProducts = [].concat(_toConsumableArray(state.products));
  updatedProducts[productIndex] = payload;
  return Object.assign({}, state, {
    products: updatedProducts
  });
};
var handleReceiveAccountPositionEvent = function handleReceiveAccountPositionEvent(state, payload) {
  var idx = state.products.findIndex(function (p) {
    return p.AccountPosition.ProductId === payload.ProductId;
  });
  var products = [].concat(_toConsumableArray(state.products));
  products.splice(idx, 1, Object.assign({}, state.products[idx], {
    AccountPosition: payload
  }));
  return Object.assign({}, state, {
    products: products
  });
};